import { ArrowDownToLine, Send, Vault, CreditCard, Blocks, Repeat } from "lucide-react";
import { Reveal } from "./Reveal";
import { CAPABILITIES } from "../../lib/content";

const icons = { ArrowDownToLine, Send, Vault, CreditCard, Blocks, Repeat };

export const Capabilities = () => (
  <section id="platform" className="bg-[#FAFAFB] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <p className="overline mb-4">The platform</p>
        <h2 className="font-heading max-w-2xl text-3xl font-medium tracking-tight text-[#0A0C14] sm:text-4xl lg:text-5xl">
          Six capabilities. One ledger. <span className="text-slate-400">Zero patchwork.</span>
        </h2>
        <p className="mt-5 max-w-xl text-base text-slate-600 lg:text-lg">
          Nobody else offers acceptance, payouts, balances, cards and white-label embedding as one platform — with real compliance underneath.
        </p>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-12">
        {CAPABILITIES.map((c, i) => {
          const Icon = icons[c.icon];
          return (
            <Reveal key={c.n} delay={i * 0.06} className={c.span}>
              <article
                data-testid={`capability-card-${c.title.toLowerCase().replace(" ", "-")}`}
                className={`group h-full rounded-3xl p-8 lg:p-10 ${
                  c.featured
                    ? "relative overflow-hidden border border-transparent bg-[#0A0C14] shadow-[0_24px_60px_rgba(10,12,20,0.25)]"
                    : "nx-card"
                }`}
              >
                {c.featured && <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-[#3B5FE8]/30 blur-[90px]" aria-hidden="true" />}
                <div className="relative flex items-start justify-between">
                  <span className={`flex h-12 w-12 items-center justify-center rounded-2xl transition-colors duration-300 ${c.featured ? "bg-[#3B5FE8] text-white" : "bg-[#E8EDFF] text-[#3B5FE8] group-hover:bg-[#3B5FE8] group-hover:text-white"}`}>
                    <Icon size={22} strokeWidth={1.8} />
                  </span>
                  <span className={`font-mono text-sm ${c.featured ? "text-white/30" : "text-slate-300"}`}>{c.n}</span>
                </div>
                <h3 className={`font-heading relative mt-10 text-2xl font-medium tracking-tight lg:text-3xl ${c.featured ? "text-white" : "text-[#0A0C14]"}`}>{c.title}</h3>
                <p className={`relative mt-3 max-w-md text-sm leading-relaxed lg:text-base ${c.featured ? "text-slate-400" : "text-slate-600"}`}>{c.desc}</p>
                <div className="relative mt-7 flex flex-wrap gap-2">
                  {c.tags.map((t) => (
                    <span key={t} className={`rounded-full border px-3 py-1 font-mono text-[11px] ${c.featured ? "border-white/15 text-white/70" : "border-slate-200 text-slate-500"}`}>{t}</span>
                  ))}
                </div>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
